import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Concatène des classes conditionnelles et résout les conflits Tailwind.
 *
 * `clsx` gère les conditions, `twMerge` garantit que la dernière classe d'une
 * même famille l'emporte : `cn('px-2', 'px-4')` donne `px-4` et non les deux,
 * ce qui rend les surcharges via prop `className` prévisibles.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
